var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardMarketing = function SvgIconDashboardMarketing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "#8D3BF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31 13H17c-2.757 0-5 2.243-5 5v8c0 2.757 2.243 5 5 5h6v2h-4a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2h-4v-2h6c2.757 0 5-2.243 5-5v-8c0-2.757-2.243-5-5-5m1 9.978a1 1 0 0 1-2 0v-1.563l-3.504 3.504c-.881.882-2.418.882-3.299 0l-1.862-1.862a.333.333 0 0 0-.471 0l-3.154 3.154a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l3.154-3.154c.909-.91 2.39-.91 3.299 0l1.862 1.862c.17.17.301.17.471 0l3.504-3.504H27a1 1 0 0 1 0-2h3.5c.827 0 1.5.673 1.5 1.5z"
  })));
};
export default SvgIconDashboardMarketing;